import restGql from 'graphql-tag';

export const DeletePlan = restGql`#graphql
    mutation DeletePlan(
        $planId: String!
    ) {
        deletePlan(planId: $planId) @rest(
            type: "DeletePlan", 
            method: "DELETE",
            path: "/v2/plans/{args.planId}?version=2",
            bodyKey: "input"
        )
    }`;
